import { api } from './auth';

const UNOMI_BASE_URL = 'https://cdp.qilinsa.com:9443';
const HEADERS = {
    'Authorization': 'Basic ' + btoa('karaf:karaf'),
    'Content-Type': 'application/json'
};

// Utilitaire pour attendre
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Fonction pour récupérer la configuration utilisateur
const getUserConfig = () => {
    const configStr = localStorage.getItem('userConfig');
    console.log('Configuration brute depuis localStorage:', configStr);
    
    const config = configStr ? JSON.parse(configStr) : {
        brand: '',
        mautic_url: '',
        mautic_username: '',
        mautic_password: ''
    };
    
    console.log('Configuration parsée:', config);
    return config;
};

// Fonction pour mettre à jour la configuration utilisateur
const updateUserConfig = (newConfig) => {
    const currentConfig = getUserConfig();
    const updatedConfig = { ...currentConfig, ...newConfig };
    localStorage.setItem('userConfig', JSON.stringify(updatedConfig));
    return updatedConfig;
};

// ===== LLM Configuration Management =====
// Cache for LLM configuration to avoid repeated API calls
let llmConfigCache = null;
let llmConfigPromise = null;

/**
 * Fetch LLM configuration from backend (provider, model, temperature)
 * Results are cached to minimize API calls
 * 
 * The configuration comes from backend .env file (DEFAULT_PROVIDER, DEFAULT_MODEL, DEFAULT_TEMPERATURE)
 * Hardcoded values below are only used as last-resort fallbacks if backend is unavailable
 */
export const fetchLLMConfig = async () => {
    // Return cached config if available
    if (llmConfigCache) {
        return llmConfigCache;
    }

    // If a fetch is already in progress, return that promise
    if (llmConfigPromise) {
        return llmConfigPromise;
    }

    // Start a new fetch
    llmConfigPromise = (async () => {
        try {
            const response = await api.get('/auth/config');
            if (response.data.success && response.data.config) {
                llmConfigCache = {
                    // Values come from backend .env file
                    provider: response.data.config.default_provider,
                    model: response.data.config.default_model,
                    temperature: response.data.config.default_temperature
                };
                console.log('[LLM Config] Configuration fetched from backend:', llmConfigCache);
                return llmConfigCache;
            } else {
                throw new Error('Invalid config response');
            }
        } catch (error) {
            console.error('[LLM Config] Error fetching configuration, using fallback defaults:', error);
            // Last-resort fallback values (only used if backend is unreachable)
            llmConfigCache = {
                provider: 'google',
                model: 'gemini-2.5-pro',
                temperature: 0.0
            };
            return llmConfigCache;
        } finally {
            llmConfigPromise = null;
        }
    })();

    return llmConfigPromise;
};

/**
 * Get cached LLM configuration synchronously
 * Returns fallback defaults if config hasn't been fetched yet
 * Note: These hardcoded values are only temporary until fetchLLMConfig() completes
 */
export const getLLMConfig = () => {
    if (llmConfigCache) {
        return llmConfigCache;
    }
    // Return fallback defaults if not yet fetched (temporary until backend config loads)
    return {
        provider: 'google',
        model: 'gemini-2.5-pro',
        temperature: 0.0
    };
};

/**
 * Clear LLM configuration cache (useful for testing or forcing refresh)
 */
export const clearLLMConfigCache = () => {
    llmConfigCache = null;
    llmConfigPromise = null;
};

export {
    UNOMI_BASE_URL,
    HEADERS,
    sleep,
    getUserConfig,
    updateUserConfig
};

export const BATCH_SIZE = 20;      // Taille des lots pour les requêtes
export const BATCH_DELAY = 20;     // Délai entre les requêtes (ms)
export const BATCH_PAUSE = 200;    // Pause entre les lots (ms)

// URL de base de l'API backend
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// URL de base de l'API "inbox" (discussions clients) - inspirée de frontend2
export const INBOX_API_BASE_URL = process.env.REACT_APP_INBOX_API_BASE_URL;

// Global feature flag to grey-out/disable undeveloped UI
export const GREY_UNDEVELOPED_UI = String(process.env.REACT_APP_GREY_UNDEVELOPED_UI || '').toLowerCase() === 'true';

// Feature flag to hide incomplete functionality (like Analyse & IA)
export const HIDE_INCOMPLETE_FEATURES = String(process.env.REACT_APP_HIDE_INCOMPLETE_FEATURES || '').toLowerCase() === 'true';
